/**
 * Creating a Context for the current trip board user,
 * so that components on the details page can access
 * the user's profile information from anywhere.
 *
 * Example use case:
 *
 * We leverage optimistic responses for votes, so there
 * is a delay in getting the voter information back from
 * the mutation response. To improve this, we simply grab
 * the user from the Context, so that we can immediately
 * display user information instead of waiting for the
 * mutation response.
 */
import {ROLES} from '../../utils/constants';
import React from 'react';

export const TRIP_BOARD_USER = {
    isMe: true,
    profile: null,
    role: {
        type: ROLES.VIEWER
    }
};

export const tripBoardUser = (user = {...TRIP_BOARD_USER}) => {
    const usr = {...user};
    const role = user.role.type.toLowerCase();
    // computed properties
    usr.isCollaborator = role === ROLES.COLLABORATOR.toLowerCase();
    usr.isOwner = role === ROLES.OWNER.toLowerCase();
    usr.isViewer = role === ROLES.VIEWER.toLowerCase();
    return usr;
}

export const UserContext = React.createContext(tripBoardUser(TRIP_BOARD_USER));

/**
 * The current trip board user's role can change between trip board
 * views. Some boards the user will be owner of, others a collaborator
 * or viewer. This component keeps the user data for the UserContext
 * provider up-to-date between trip board views.
 */
export class UserProvider extends React.Component {
    static defaultProps = {...TRIP_BOARD_USER};

    constructor(props) {
        super(props);
        const {children, ...rest} = props; // eslint-disable-line no-unused-vars
        this.state = tripBoardUser({
            ...TRIP_BOARD_USER,
            ...rest
        });
    }

    componentWillReceiveProps(nextProps) {
        const {children, ...rest} = nextProps; // eslint-disable-line no-unused-vars
        const user = tripBoardUser({...rest});
        this.setState(user);
    }

    render() {
        return (
            <UserContext.Provider value={this.state}>
                {this.props.children}
            </UserContext.Provider>
        );
    }
}

export function withUser(Component) {
    return function UserComponent(props) {
        return (
            <UserContext.Consumer>
                {(user) => <Component {...props} user={user}/>}
            </UserContext.Consumer>
        );
    };
}




// WEBPACK FOOTER //
// ./src/universal/tripboard/user/user.js